<!-- <div class="overlay">

    <p>This is a fixed overlay.</p>
</div> -->
<app-loader></app-loader>

<router-outlet> </router-outlet>

